import {styled} from "@core-ui/react-stitch";

const CardInfo = styled.div(() => ({
  marginLeft: "8px",
}));

export default CardInfo;
